import { HeadingLevelPicker } from "./Content/HeadingLevelPicker";
import { Text } from "./Content/Text";

export const ContentEditor = () => (
  <div className="px-6 py-2">
    <Text />
    <HeadingLevelPicker />
  </div>
);
